export default "/images/chipiona.webp?65d37c0f2950f264bc85005e095569a0";